<loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>

@if (allSetNodes?.length) {
    <div class="flex flex-col gap-4 items-center justify-center">
        <div class="flex flex-col min-w-[50%] max-w-[95%] bg-ponder-light rounded shadow">
            <div class="flex flex-row gap-2 p-2 pb-1 text-slate-50 items-center">
                <svg class="size-6 filter-magic-display" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 100" stroke-width="1">
                    <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="magicSvgIcon" ></path>
                </svg>
                <div class="text-sm sm:text-base grow">Magic: The Gathering</div>
                <input #filterInput (input)="onFilterChange(filterInput.value)" class="p-1 rounded-sm shadow-sm text-sm bg-ponder-xlight text-faded-90 shrink" placeholder="Filter"/>
            </div>
            <div class="flex flex-row gap-4 text-xs pl-2 pr-2 text-slate-50">
                <div>August 5, 1993</div>
                <div>{{ allSetNodes!.length | number }} sets</div>
                <div>{{ totalCards | number }} cards</div>
            </div>
            <div class="bg-slate-100 rounded-b">
                <div #setTable class="flex flex-col">
                    <div class="flex flex-row text-xs sm:text-sm font-bold pt-1 pb-1 shadow">
                        <div class="pl-2 pr-2 grow"><span class="text-sm">Set Name</span></div>
                        <div class="pl-2 pr-2 min-w-[10ch] max-w-[10ch]"><span class="text-sm">Code</span></div>
                        <div class="pl-2 pr-2 min-w-[10ch] max-w-[10ch] hidden sm:inline"><span class="text-sm">Cards</span></div>
                        <div class="pl-2 pr-2 min-w-[12ch] max-w-[12ch] hidden sm:inline"><span class="text-sm">Released</span></div>
                    </div>
                    @for (set of visibleNodes ; track set.set!.id) {
                        @if ($index <= visibleCount) {
                            <a href="/magic/set/{{ set.set!.code }}" class="flex flex-row items-center text-xs sm:text-sm hover:bg-ponder-linkhover hover:bg-opacity-15 border-t-[1px] cursor-pointer" [ngClass]="{ 'bg-slate-50' : $odd }">
                                <div class="flex flex-row grow gap-2 pl-2 pr-2 sm:pr-8 truncate">
                                    <magic-set-icon [style.padding-left]="set.depthClass" [setCode]="set.set!.code!" filterClass="filter-icon-ponder-xlight" [small]="true" class="flex flex-row items-center"></magic-set-icon>
                                    <div class="pt-2 pb-2 truncate sm:max-w-[100ch]">{{ set.set!.name }}</div>
                                </div>
                                <div class="pl-2 pr-2 min-w-[10ch] max-w-[10ch]">
                                    {{ set.set!.code | uppercase }}
                                </div>
                                <div class="pl-2 pr-2 min-w-[10ch] max-w-[10ch] hidden sm:inline">
                                    {{ set.set!.cardCount | number }}
                                </div>
                                <div class="pl-2 pr-2 min-w-[12ch] max-w-[12ch] hidden sm:inline">
                                    {{ set.set!.releaseDate! | date }}
                                </div>
                            </a>
                        }
                    }
                </div>
                @if (visibleNodes!.length > visibleCount) {
                    <div class="bg-slate-100 rounded-b text-slate-400 text-center text-xs pt-2 pb-2 italic">
                        ... Scroll to view more sets ...
                    </div>
                } @else {
                    <div class="bg-slate-100 h-[3px] rounded-b"></div>
                }
            </div>
        </div>
    </div>
}